var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.50002 3.5625C10.8275 3.5625 12.0163 4.02 12.9538 4.9125L15.5225 2.34375C13.9625 0.8925 11.9263 0 9.50002 0C5.98252 0 2.94127 2.0175 1.46002 4.9575L4.45252 7.27875C5.16127 5.145 7.15252 3.5625 9.50002 3.5625Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.1175 9.20625C18.1175 8.6175 18.0612 8.0475 17.975 7.5H9.5V10.8825H14.3525C14.135 11.9925 13.505 12.9375 12.56 13.575L15.4588 15.825C17.15 14.2575 18.1175 11.94 18.1175 9.20625Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.44875 10.7213C4.26875 10.1775 4.16375 9.60002 4.16375 9.00002C4.16375 8.40002 4.265 7.82252 4.44875 7.27877L1.45625 4.95752C0.845 6.17252 0.5 7.54502 0.5 9.00002C0.5 10.455 0.845 11.8275 1.46 13.0425L4.44875 10.7213Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.49999 17.9998C11.93 17.9998 13.9737 17.201 15.4587 15.821L12.56 13.571C11.7537 14.1148 10.715 14.4335 9.49999 14.4335C7.15249 14.4335 5.16124 12.851 4.44874 10.7173L1.45624 13.0385C2.94124 15.9823 5.98249 17.9998 9.49999 17.9998Z",
    fill: "#34A853"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/IconGoogle.4da050d3cfee6e364f8b8876228fdc32.svg";
export { ForwardRef as ReactComponent };